// axiosPrivate file
import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_URL;
const headers = {
    'Content-Type': 'application/json',
    'AccessControl-Allow-Origin' : 'http://localhost:3000',
};

export default axios.create({
    baseURL: baseURL,
    headers: headers
});

export const axiosPrivate = axios.create({
    baseURL: baseURL,
    headers: headers
});

// Add response interceptor to handle 401 errors globally
axiosPrivate.interceptors.response.use(
    (response) => {
        // If response is successful, just return it
        return response;
    },
    (error) => {
        // Check if error is 401 (Unauthorized)
        if (error.response?.status === 401) {
            // Clear any stored authentication data
            // This depends on how you store auth data (localStorage, cookies, etc.)
            
            // For cookies (based on your PrivateRoute usage)
            document.cookie = "SIDikey=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            
            // For localStorage
            // localStorage.removeItem('token');
            // localStorage.removeItem('user');
            
            // Redirect to login page
            window.location.href = `${process.env.PUBLIC_URL}/auth-login`;
        }
        
        // Return the error for other status codes
        return Promise.reject(error);
    }
);